module.exports = __webpack_public_path__ + "static/media/team.ae289d63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/team.jpg
// module id = 191
// module chunks = 0